import axios from 'axios';
import { url, endPoint } from '../urls';

export const addAlert = (params) => {
    let _url = url.backendHost + endPoint.alert.addAlert;
    return axios.post(_url, params);
}

export const updateAlert = (params) => {
    let _url = url.backendHost + endPoint.alert.updateAlert;
    return axios.post(_url, params);
}

export const alertList = (params) => {
    let _url = url.backendHost + endPoint.alert.alertList;
    return axios.post(_url, params);
}

export const runAlert = (params) => {
    let _url = url.backendHost + endPoint.alert.runAlert;
    return axios.post(_url, {params});
}
export const runAllAlert = (params) => {
    let _url = url.backendHost + endPoint.alert.runAllAlert;
    return axios.get(_url);
}

export const deleteAlert = (params) => {
    let _url = url.backendHost + endPoint.alert.deleteAlert;
    return axios.post(_url, params);
}

export const getReportLink = (params) => {
    let _url = url.backendHost + endPoint.alert.getReportLink;
    return axios.post(_url, {params});
}